import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Dropdown } from '@fluentui/react/lib/Dropdown';
import type { SearchFilterOption } from 'owa-timestream-asset-search';
import useDropdownSearchRefinerState from '../../hooks/useDropdownSearchRefinerState';

export default observer(function DropdownSearchRefiner({ option }: { option: SearchFilterOption }) {
    const { onChange } = useDropdownSearchRefinerState({ option });

    if (option.type !== 'Dropdown') {
        return null;
    }

    return (
        <Dropdown
            label={option.label}
            selectedKey={option.value}
            onChange={onChange}
            options={option.options}
            styles={{
                dropdown: { width: 208 },
                dropdownItemsWrapper: { width: 208, maxHeight: 252 },
                label: { fontSize: 12 },
            }}
        />
    );
});
